import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

/**
 * The group classes live right now (the server's own list, /api/live-now).
 * Shared by the nav's Live now pill and AF Studio's Live classes row, so one
 * request every 30 seconds serves both.
 */
const QUERY_KEY = ['liveNow'];

async function fetchLiveClasses() {
  const res = await axios.get('/api/live-now');
  return Array.isArray(res.data?.classes) ? res.data.classes : [];
}

export function useLiveClasses() {
  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchLiveClasses,
    refetchInterval: 30 * 1000,
    staleTime: 15 * 1000,
  });
  return { liveClasses: query.data || [], ...query };
}
